import { render } from "./MasterDataListIFrame.vue?vue&type=template&id=bd76eb5c&ts=true"
import script from "./MasterDataListIFrame.ts?vue&type=script&lang=ts&external"
export * from "./MasterDataListIFrame.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__